import React from 'react';
import { Column, Copy, Flex, Stack } from '@grubhubprod/gh-cookbook-react/dist';
import { useCorporateFormContext } from 'src/components/enterprise/features/Corporate/components/Form/CorporateFormProvider/useCorporateFormContext';

export function IntacctStatus(): JSX.Element {
  const { isEditPage, corpData } = useCorporateFormContext();

  if (!isEditPage) {
    return null;
  }

  return (
    <Column phone={6} gutter={12}>
      <Stack y="sm">
        <Flex>
          <Stack x="xxx-sm">
            <Copy variant="body" color="secondaryText">
              Intacct Status:
            </Copy>
          </Stack>
          <Copy variant="body">{corpData.intacctStatus}</Copy>
        </Flex>
      </Stack>
    </Column>
  );
}
